import SetLinkModal from '../../components/SetLinkModal/SetLinkModal';
const Modals = {
    VIDEO_LINK: 'video-link'
};
const ModalsMap = {
    [Modals.VIDEO_LINK]: SetLinkModal
};
export { Modals, ModalsMap };
